export const getDollars = (amount = NaN) => {
  return amount.toFixed(2);
};

export const getCents = (amount = NaN) => {
  return +amount.toString().split('.')[1];
};

export const formatAttributeCombination = ({ combinationName }) => {
  if (!combinationName) return null;
  let formattedName = combinationName;

  if (combinationName.includes('~~')) {
    let tokens = combinationName.split('~~').slice(0, 2);
    if (tokens.includes('Other')) {
      formattedName = tokens[0];
    } else {
      formattedName = tokens.join(', ');
    }
  }

  return formattedName;
};
